import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=1f70335d&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=1f70335d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70335d",
  null
  
)

export default component.exports